module.exports = __webpack_public_path__ + "img/water side -111.54a1670e.jpeg";